var React = require('react');

function LightMode (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"23","cy":"23","r":"22.5","stroke":"#09192B","strokeOpacity":"1","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22 12.05H24V15H22V12.05ZM15.96 14.55L17.76 16.34L16.34 17.75L14.55 15.96L15.96 14.55ZM15 22H12V24H15V22ZM31.4476 15.952L30.0404 14.545L28.2515 16.3339L29.6586 17.741L31.4476 15.952ZM28.24 29.66L30.03 31.46L31.44 30.05L29.64 28.26L28.24 29.66ZM34 22H31V24H34V22ZM23 17C19.69 17 17 19.69 17 23C17 26.31 19.69 29 23 29C26.31 29 29 26.31 29 23C29 19.69 26.31 17 23 17ZM19 23C19 25.21 20.79 27 23 27C25.21 27 27 25.21 27 23C27 20.79 25.21 19 23 19C20.79 19 19 20.79 19 23ZM22 31H24V33.95H22V31ZM15.96 31.45L14.55 30.04L16.34 28.24L17.75 29.65L15.96 31.45Z","fill":"#09192B","key":1})]);
}

LightMode.defaultProps = {"width":"46","height":"46","viewBox":"0 0 46 46","fill":"none"};

module.exports = LightMode;

LightMode.default = LightMode;
